<template>
    <Head title="IMPACT Leader Code Self-Reflection" />
    <SchneiderAssessmentContent v-bind="props" />
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import SchneiderAssessmentContent from "~vue/pages/schneiderAssessment/SchneiderAssessmentContent.vue";

export interface Question {
    index: number;
    competency: string;
    title: string;
    description: string;
}

export interface Props {
    questions: Question[];
    competency_definitions: Record<string, string>;
    rating_labels: Record<string, string>;
    rating_short_descriptions: Record<string, string>;
    rating_descriptions: Record<string, string>;
    saved_responses?: Record<number, number>;
    draft_assessment_id?: string | null;
    completed_responses?: Record<number, number>;
    completed_assessment_id?: string | null;
    coaching_session_url?: string | null;
    gather_feedback_url?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
    saved_responses: () => ({}),
    draft_assessment_id: null,
    completed_responses: () => ({}),
    completed_assessment_id: null,
    coaching_session_url: null,
    gather_feedback_url: null,
});
</script>
